import { contactsRouteNames, conversationRouteNames } from '../routes/constants/location'

import PerformanceMonitoringService from '../services/PerformanceMonitoringService';
import { Route } from 'vue-router'
import { User } from '../models'
import store from '../store'
import { universityRoutes } from '../routes/constants/agency/'
import { v4 as uuid } from 'uuid'

export const dispatchCustomEvents = (
  event: string,
  params: { [key: string]: any }
) => {
  if (CustomEvent !== undefined) {
    window.dispatchEvent(new CustomEvent(event, params))
  }
}

export const refreshFirebaseToken = async (loc_id: string) => {
  await store.dispatch(
    'auth/refreshFirebaseToken',
    { locationId: loc_id || null, refresh: true },
    { root: true }
  )
}

export const handleExternalRedirect = async (to: Route) => {
  let url: string = to.meta.RedirectExternalUrl as string
  if (to.name == universityRoutes.default) {
    try {
      const user = new User(await store.dispatch('user/get'))
      url += `&email=${user.email}`
    } catch (err) { }
  }
  window.open(url, '_blank')?.focus()
}

export const dispatchConversationsV2SyncAll = async (
  to: Route,
  from: Route
) => {
  if (from.name === conversationRouteNames.conversationsIdV2 && from.name !== to.name) {
    // mytodo: check if any change is needed in syncAllV2  & is dispatchConversationsV2SyncAll relevent for group chat
    await store.dispatch('conversationV2/syncAllV2', {
      locationId: to.params.location_id,
      noListener: true,
      stickyFilterEnabled: store?.getters?.['featureFlags/getForLocation'](
        'conversations.stickyFilters'
      ),
    })
  }
}

export const dispatchSyncAlls = (loc_id: string, userId: string, routePathParams?: any) => {
  return Promise.allSettled([
    store.dispatch('locations/resetCurrentLocation', {
      locationId: loc_id,
    }),
    store.dispatch('users/syncAll', loc_id),
    store.dispatch('locationCustomFields/syncAll', {
      locationId: loc_id,
    }),
    store.dispatch('customObjectsStore/syncAll', loc_id),
    store.dispatch('featureFlags/syncAll', loc_id),
    store.dispatch('adPublishing/syncAll', loc_id),
    store.dispatch('conversationV2/updatePhoneNumbers', []),
    store.dispatch('conversationChannels/updateDefaultChannels', {}),
    store.dispatch('calendars/syncSubAccountConfig', loc_id),
    store.dispatch('conversationAi/fetchConversationAIOptInForLocation', {entityId:loc_id}),
    store.dispatch('clientPortal/getLocationConfiguration', {locationId:loc_id}),
    // store.dispatch('aiLocationPlan/syncAll', {locationId:loc_id})
    store.dispatch('aiLocationPlan/fetchShowSummerOfAIMenu', {locationId:loc_id})
  ])
}

export const getHTMLElements = () => {
  const element = document.getElementById('app')
  const htmlTag = document.getElementsByTagName('html')[0]
  htmlTag.className = 'overflow-hidden lead-connector'
  return [element, htmlTag]
}

export const setSidebarState = (to: Route, from: Route) => {
  const sideBarRoute = ['contact_detail']
  const sideBarV2Route = [contactsRouteNames.contactDetail]
  if (to.name && sideBarRoute.includes(to.name)) {
    store.commit('setSideBarState', true)
  } else if (from.name && sideBarRoute.includes(from.name)) {
    store.commit('setSideBarState', false)
  }

  if (
    (to.name && sideBarRoute.includes(to.name)) ||
    (from.name && sideBarRoute.includes(from.name))
  ) {
    store.commit('setSideBarState', false)
  }
}
